const days = []
for (let i = 1; i < 32; i++) {
  if (i < 10) {
    i = `0${i}`
  }
  days.push(i.toString())
}

const years = []
for (let i = 2018; i > 1900; i--) {
  years.push(i.toString())
}

export const fieldOptions = {
  gender: [
    { value: null, label: '-- Select Gender --' },
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
  ],
  units: [
    { value: null, label: '-- Select Units --' },
    { value: 'us', label: 'US (lb/inches)' },
    { value: 'metric', label: 'Metric/SI (cm/kg)' },
  ],
  monthSelect: [
    { label: 'Month', value: '' },
    { label: 'January', value: '01' },
    { label: 'February', value: '02' },
    { label: 'March', value: '03' },
    { label: 'April', value: '04' },
    { label: 'May', value: '05' },
    { label: 'June', value: '06' },
    { label: 'July', value: '07' },
    { label: 'August', value: '08' },
    { label: 'September', value: '09' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
  ],
  daySelect: [{ label: 'Day', value: '' }].concat(
    days.map((day) => ({ label: day, value: day }))
  ),
  yearSelect: [{ label: 'Year', value: '' }].concat(
    years.map((year) => ({ label: year, value: year }))
  ),
}
